import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

/**
 * Compact checkbox for admin filter toolbars — label row matches FilterFieldSelect.
 */
export default function FilterFieldCheck({ id, label, checked, onChange, className, disabled = false }) {
  return (
    <div className={classNames('flex-shrink-0 d-flex flex-column', className)}>
      <span className="form-label d-block user-select-none" aria-hidden="true">
        &nbsp;
      </span>
      <div className="form-check m-0 d-flex align-items-center" style={{ minHeight: '38px' }}>
        <input
          className="form-check-input mt-0"
          type="checkbox"
          id={id}
          checked={checked}
          onChange={onChange}
          disabled={disabled}
        />
        <label className="form-check-label text-nowrap ms-2 mb-0" htmlFor={id}>
          {label}
        </label>
      </div>
    </div>
  );
}

FilterFieldCheck.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  className: PropTypes.string,
  disabled: PropTypes.bool,
};
